import styled, { css } from 'styled-components';
import { darken } from 'polished';

export const Container = styled.div`
  padding: 20px;
  color: #e9ecef;
  overflow-y: auto;
  height: 100%;
  &::-webkit-scrollbar-track {
    background-color: #2a3142;
  }
  &::-webkit-scrollbar {
    width: 6px;
    background: #eee;
  }
  &::-webkit-scrollbar-thumb {
    background: #eee;
  }

  h4 {
    color: #e9ecef;
    font-size: 18px;
    line-height: 30px;
    font-weight: 700;
  }

  span {
    font-size: 14px;
    color: rgba(255, 255, 255, 0.7);
    font-family: 'Roboto', sans-serif;
  }

  textarea {
    border: 1px solid rgba(255, 255, 255, 0.07);
    border-radius: 4px;
    color: #dee2e6;
    background: #323a4e;
    padding: 10px 20px;
    height: 300px;
    width: 100%;
    resize: none;
    margin-top: 0.8rem;

    &::-webkit-scrollbar-track {
      background-color: #2a3142;
    }
    &::-webkit-scrollbar {
      width: 6px;
      background: #eee;
    }
    &::-webkit-scrollbar-thumb {
      background: #eee;
    }
  }

  label {
    font-size: 14px;
    color: rgba(255, 255, 255, 0.7);
    font-family: 'Roboto', sans-serif;
    font-weight: 700;
  }
`;

export const Label = styled.div`
  margin-top: 20px;
  margin-bottom: 20px;
  > span {
    color: #e0042d;
    font-size: 1.2rem;
    font-weight: 500;
    line-height: 1.3;
    width: 100%;
    margin: 0.6rem 0 0.4rem;
    border-radius: 4px;
    transform: none;
    animation: fadeIn 350ms ease-in-out 1;
    @keyframes fadeIn {
      from {
        transform: translateY(-20px);
        opacity: 0;
      }
      to {
        transform: translateY(0);
        opacity: 1;
      }
    }
  }

  p {
    margin-bottom: 10px;
    font-size: 14px;
    color: rgba(255, 255, 255, 0.7);
    font-family: 'Roboto', sans-serif;
    font-weight: bold;
  }

  ${props =>
    props.small &&
    css`
      textarea {
        height: 200px;

        &::placeholder {
          color: #fff;
        }
      }
    `}
`;

export const Button = styled.button.attrs({
  type: 'submit',
})`
  background: #626ed4;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 0;
  padding: 10px;
  color: #fff;
  border-radius: 4px;
  transition: background 0.2s;
  margin-top: 10px;

  &:hover {
    background: ${darken(0.04, '#626ed4')};
  }
`;
